import React, { useEffect, useState } from 'react';
import { adminApi } from '../../api/client';
import StatCard from '../../components/common/StatCard';
import Spinner  from '../../components/common/Spinner';
import { FaGraduationCap, FaChalkboardTeacher, FaLayerGroup, FaBook, FaBullhorn, FaCalendarAlt } from 'react-icons/fa';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

export default function AdminDashboard() {
  const [stats,   setStats]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.getStats()
      .then(r => setStats(r.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;

  return (
    <div>
      <div className="page-header">
        <h2>Admin Dashboard</h2>
        <p>Overview of your school's activity</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 16, marginBottom: 28 }}>
        <StatCard label="Total Learners"   value={stats?.total_learners}    icon={FaGraduationCap}      color="#0d6efd" />
        <StatCard label="Total Teachers"   value={stats?.total_teachers}    icon={FaChalkboardTeacher}  color="#10b981" />
        <StatCard label="Grades"           value={stats?.total_grades}      icon={FaLayerGroup}         color="#f59e0b" />
        <StatCard label="Subjects"         value={stats?.total_subjects}    icon={FaBook}               color="#8b5cf6" />
        <StatCard label="Active Notices"   value={stats?.active_notices}    icon={FaBullhorn}           color="#ef4444" />
        <StatCard label="Present Today"    value={stats?.present_today}     icon={FaCalendarAlt}        color="#06b6d4" sub="learners present" />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        {/* Attendance chart */}
        <div className="sms-card">
          <h5 style={{ fontWeight: 600, marginBottom: 16 }}>Attendance — Last 7 Days</h5>
          {stats?.attendance_week?.length > 0 ? (
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={stats.attendance_week} barGap={4}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
                <XAxis dataKey="date" tickFormatter={d => new Date(d).toLocaleDateString('en', { weekday: 'short' })} tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} />
                <Tooltip />
                <Bar dataKey="present" fill="#10b981" radius={[4,4,0,0]} name="Present" />
                <Bar dataKey="absent"  fill="#ef4444" radius={[4,4,0,0]} name="Absent" />
                <Bar dataKey="late"    fill="#f59e0b" radius={[4,4,0,0]} name="Late" />
              </BarChart>
            </ResponsiveContainer>
          ) : <p style={{ color: '#9ca3af', textAlign: 'center', padding: '40px 0' }}>No attendance data yet</p>}
        </div>

        {/* Recent notices */}
        <div className="sms-card">
          <h5 style={{ fontWeight: 600, marginBottom: 16 }}>Recent Notices</h5>
          {stats?.recent_notices?.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {stats.recent_notices.map(n => (
                <div key={n.notice_id} style={{ padding: '12px 14px', background: '#f9fafb', borderRadius: 10, borderLeft: '3px solid #0d6efd' }}>
                  <div style={{ fontWeight: 500, fontSize: '0.9rem' }}>{n.title}</div>
                  <div style={{ color: '#9ca3af', fontSize: '0.78rem', marginTop: 2 }}>{new Date(n.created_at).toLocaleDateString()}</div>
                </div>
              ))}
            </div>
          ) : <p style={{ color: '#9ca3af', textAlign: 'center', padding: '40px 0' }}>No notices yet</p>}
        </div>
      </div>
    </div>
  );
}
